import {
  ChartDataSets,
  ChartOptions,
  ChartScales,
  ChartXAxe,
  ChartYAxe,
  TickOptions,
  TimeScale,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";
import { baseOption, colors } from "../../utils";

interface LineChartOptions {
  data: any[];
}

const lineOptions: ChartOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        position: "bottom",
        type: "time",
        distribution: "linear",
        time: {
          unitStepSize: 3,
          minUnit: "month",
          unit: "month",
        } as TimeScale,
      },
    ] as ChartXAxe[],
    yAxes: [
      {
        position: "left",
        ticks: {
          beginAtZero: true,
        } as TickOptions,
        scaleLabel: {
          display: true,
          labelString: "",
        },
      },
    ] as ChartYAxe[],
  } as ChartScales,
  legend: {
    display: true,
    position: "right",
    labels: {
      padding: 20,
    },
  },
  maintainAspectRatio: false,
};

export const LineChart: React.FC<LineChartOptions> = (props) => {
  const { data } = props;

  return (
    <Line
      data={{
        datasets: data.map((row, index) => {
          return {
            ...row,
            ...baseOption(colors[index]),
          } as ChartDataSets;
        }),
      }}
      options={lineOptions}
    />
  );
};
